import { Link } from '@lingoda/ui';
import { trans } from '@lingoda/i18n';
import type { Path } from '@lingoda/router';
import { Grid, type GridProps } from '@lingoda/ui/layout/GridNext';
import { businessEnglishPath, corporatePath, sectionRedirectPath } from '@lingoda/router';

interface Props {
    mb?: GridProps['mb'];
}

export const SectionLinks = ({ mb }: Props) => {
    return (
        <Grid container spacing={2} mb={mb}>
            {Object.entries(links).map(([name, path]) => (
                <Grid key={name} xs={6} sm={4} md={12}>
                    <Link key={name} to={path}>
                        {trans(
                            // If the type is used from generated types, we have to assing it manually
                            // either global or al type instead of global one from generated.
                            // if the type already came from our models SectionName type, it would work
                            // So translations-extractor could see it and pass section values
                            `navigation.language-selector-${name as SectionName}`,
                            {},
                            'public-common',
                        )}
                    </Link>
                </Grid>
            ))}
            <Grid xs={6} sm={4} md={12}>
                <Link to={businessEnglishPath()}>
                    {trans('navigation.business-english', {}, 'public-common')}
                </Link>
            </Grid>
            <Grid xs={6} sm={4} md={12}>
                <Link to={corporatePath()}>
                    {trans('navigation.corporate', {}, 'public-common')}
                </Link>
            </Grid>
        </Grid>
    );
};

const links: Record<SectionName, Path> = {
    english: sectionRedirectPath('english'),
    french: sectionRedirectPath('french'),
    german: sectionRedirectPath('german'),
    spanish: sectionRedirectPath('spanish'),
    italian: sectionRedirectPath('italian'),
};
